import Vue from 'vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { BootstrapVue } from 'bootstrap-vue'
import './core/Styles/main.styl'

import App from './App.vue'

import './registerServiceWorker'
import router from './router'
import store from './store'
import moment from 'moment'
import Fragment from 'vue-fragment'
import {VueOfflineMixin} from "./core/Mixins/vue-offline";
import {MessageMixin} from "./core/Mixins/message";
import {UserGuestMixin} from "./core/Mixins/user-guest";
import {Analytics} from './core/Utils'
import EnglishMessages from './englishmessages';

Vue.filter('shortDate', function(value) {
    if (value) {
        return moment(String(value)).format('LL')
    }
})

// global mixin for app build type
Vue.mixin({
    data: function() {
        return {
            get isIntuitApp() {
                return process.env.VUE_APP_BUILD === 'INTUIT'
            },
            get isJAUSApp() {
                return process.env.VUE_APP_BUILD === 'JA_US'
            },
            get isJAOtherApp() {
                return process.env.VUE_APP_BUILD === 'JA_OTHER'
            },
            get isJAApp() {
                return this.isJAUSApp || this.isJAOtherApp
            },
            get isJACareerApp() {
                return process.env.VUE_APP_BUILD === 'JA_CAREER'
            },
            get isJAEntrepreApp() {
                return process.env.VUE_APP_BUILD === 'JA_ENTREPRENEURSHIP'
            },
            get isJACareerEntrepreApp() {
                return this.isJACareerApp || this.isJAEntrepreApp
            },
            get isJAUSCareerEntrepreApp() {
                return this.isJAUSApp || this.isJACareerApp || this.isJAEntrepreApp
            },
        }
    }
})

Vue.mixin(VueOfflineMixin);
Vue.mixin(MessageMixin);
Vue.mixin(UserGuestMixin);
Vue.use(BootstrapVue)
Vue.use(Fragment.Plugin)
Vue.config.productionTip = false
Vue.prototype.$eventHub = new Vue();

Analytics.init()

new Vue({
    router,
    store,
    components: { EnglishMessages },
    created() {
        EnglishMessages.getMessages()
    },
    render: h => h(App)
}).$mount('#app')
